/* eslint-disable @typescript-eslint/no-floating-promises */
import {SiteStore} from '@wix/wixstores-client-storefront-sdk/dist/es/src/viewer-script/site-store/SiteStore';
import {CartType} from '@wix/wixstores-client-core/dist/es/src/types/cart';
import {QueryParamsService} from '@wix/wixstores-client-storefront-sdk/dist/es/src/services/QueryParamsService/QueryParamsService';

export class BIService {
  private readonly siteStore: SiteStore;

  constructor({siteStore}: {siteStore: SiteStore}) {
    this.siteStore = siteStore;
  }

  public thankYouPageContinueShoppingClickedSf(orderId: string): void {
    this.siteStore.biLogger.thankYouPageContinueShoppingClickedSf({orderId});
  }

  public thankYouPageDownloadFileClickedSf(orderId: string): void {
    this.siteStore.biLogger.thankYouPageDownloadFileClickedSf({orderId});
  }

  public thankYouPageLoadSf({
    orderId,
    cartId,
    shippingMethodType,
    paymentMethodType,
    cartType,
    paymentStatus,
    paymentProvider,
  }: {
    orderId: string;
    cartId: string;
    shippingMethodType: string;
    paymentMethodType: string;
    cartType: CartType;
    paymentStatus: string;
    paymentProvider: string;
  }): void {
    let originForBI;
    if (this.siteStore.experiments.enabled('specs.stores.FixCashierTypNavigationBi')) {
      const originQueryParam = new QueryParamsService(this.siteStore).getQueryParam('origin');
      originForBI = originQueryParam === 'cart-cashier' ? 'cart directly to paypal fast flow' : undefined;
    }

    this.siteStore.biLogger.thankYouPageLoadSf({
      orderId,
      cartId,
      shippingMethodType,
      paymentMethodType,
      cartType,
      paymentProvider,
      payment_status: paymentStatus,
      viewMode: this.siteStore.viewMode,
      origin: originForBI,
    });
  }
}
